import type { ReactNode } from 'react';

interface StatusPageProps {
    eyebrow: string;
    title: string;
    description: string;
    actions: ReactNode;
    /** Ilustração acima do texto (`IlustracoesDeStatus`). */
    art?: ReactNode;
    /** Dado entre a explicação e as ações (o endereço que não existe). */
    detalhe?: ReactNode;
    children?: ReactNode;
}

/** Tela cheia no padrão usual de 404/erro: logo centralizado no topo, ilustração, código, título, explicação e ações. */
export function StatusPage({ eyebrow, title, description, actions, art, detalhe, children }: StatusPageProps) {
    return (
        <div className="min-h-screen flex flex-col bg-canvas">
            <header className="flex justify-center px-6 pt-10">
                <img src="/assets/logo-alianca-app.png" alt="Aliança Renovável" className="h-11 w-auto" />
            </header>

            <main className="flex flex-1 items-center justify-center px-6 py-12">
                <div className="w-full max-w-xl text-center">
                    {art}
                    <p className="text-subhead font-semibold text-label-secondary">{eyebrow}</p>
                    <h1 className="mt-2 text-large-title text-label">{title}</h1>
                    <p className="mx-auto mt-3 max-w-md text-body text-label-secondary">{description}</p>
                    {detalhe}
                    <div className="mt-7 flex flex-col-reverse items-center justify-center gap-3 sm:flex-row">{actions}</div>
                    {children}
                </div>
            </main>
        </div>
    );
}
